'use strict';

var measurementsRaw = require('@prisjakt/design-tokens/measurements-raw');
var lib = require('./lib-75591456.js');
var definitions = require('./definitions-4ae1604d.js');
var index = require('./index-105ce710.js');

var Row = lib.variant('Row', index.List, {
    direction: definitions.Axis.X,
});
var Column = lib.variant('Column', index.List, {
    direction: definitions.Axis.Y,
});
var GridRow = lib.variant('GridRow', Row, {
    equallySizedChildren: true,
    gap: measurementsRaw.spacing100.value,
});
var GridColumn = lib.variant('GridColumn', Column, {
    equallySizedChildren: true,
    gap: measurementsRaw.spacing100.value,
});

exports.Column = Column;
exports.GridColumn = GridColumn;
exports.GridRow = GridRow;
exports.Row = Row;
//# sourceMappingURL=variants-096bd30b.js.map
